import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DynamicScreens } from '@cashier/cashier-model';

export interface CustomerInformation {
  activeScreen: DynamicScreens;
  amount: string | null;
  balance: string | null;
  currency: string;
  bonusCode: string;
  termsAgreement: {
    isCheckboxVisible: boolean;
    isChecked: boolean;
  };
}

export interface InitialiseParamsAboutCustomer {
  balance: string | null;
  currency: string;
  bonusCode: string;
}

export const CUSTOMER_INFORMATION_KEY = 'customerInformation';

export const initialCustomerInformationState: CustomerInformation = {
  amount: null,
  balance: null,
  activeScreen: DynamicScreens.PaymentForm,
  currency: 'EUR',
  bonusCode: '',
  termsAgreement: {
    isCheckboxVisible: false,
    isChecked: false,
  },
};

export const customerInformationSlice = createSlice({
  name: CUSTOMER_INFORMATION_KEY,
  initialState: initialCustomerInformationState,
  reducers: {
    initialiseCustomer: (
      state,
      { payload }: PayloadAction<InitialiseParamsAboutCustomer>,
    ) => {
      state.balance = payload.balance;
      state.currency = payload.currency;
      state.bonusCode = payload.bonusCode;
    },
    setActiveScreen: (state, { payload }: PayloadAction<DynamicScreens>) => {
      state.activeScreen = payload;
    },
    setAmount: (state, { payload }: PayloadAction<string>) => {
      state.amount = payload;
    },
    setBalance: (state, { payload }: PayloadAction<string>) => {
      state.balance = payload;
    },
    setCurrency: (state, { payload }: PayloadAction<string>) => {
      state.currency = payload;
    },
    setBonusCode: (state, { payload }: PayloadAction<string>) => {
      state.bonusCode = payload;
    },
    setTermsAgreementCheckbox: (
      state,
      {
        payload,
      }: PayloadAction<{ isCheckboxVisible: boolean; isChecked: boolean }>,
    ) => {
      state.termsAgreement.isCheckboxVisible = payload.isCheckboxVisible;
      state.termsAgreement.isChecked = payload.isChecked;
    },
  },
});

export const customerInformationReducer = customerInformationSlice.reducer;
export const {
  initialiseCustomer,
  setActiveScreen,
  setAmount,
  setBalance,
  setCurrency,
  setBonusCode,
  setTermsAgreementCheckbox,
} = customerInformationSlice.actions;
